import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
var objs = {}
const requireComponent = require.context('.',false,/.js$/);
requireComponent.keys().forEach(fileName => {
    var name = fileName.split(".")[1];
    name = name.substr(1,name.lenght);
    if(name != "index"){
        objs[name] = requireComponent(fileName).default
    }
})
export default objs;


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/index.js